
export default {
    Create : 0,
    Edit : 1,
    DuelResponse : 2,
}

